import { render } from "./Blob.vue?vue&type=template&id=2aee7a08&scoped=true"
import script from "./Blob.vue?vue&type=script&lang=js"
export * from "./Blob.vue?vue&type=script&lang=js"

import "./Blob.vue?vue&type=style&index=0&id=2aee7a08&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aee7a08"]])

export default __exports__